import queryReacoes, { type QueryReacoesRequest } from 'bula-certa-commons/service/notificacoes/query-notificacoes-vigimed'

export { type QueryReacoesRequest }

export default queryReacoes